import React from 'react';
import Legend from './Legend';
import COLORS from 'constants/colors';
import { getMessage } from '@tcc/i18n';
import { GeneratedZone } from 'store/types/types';
import { getDisplayValuesForZonesProductivityLegend } from 'manual/util/zone-generation';

const ProductivityLegend = ({ zones }: { zones: Record<string, GeneratedZone> }) => {
  const zonesList = Object.values(zones);
  const hasMissingDataZone = zonesList.some((zone) => zone.geoJson.properties.isDeadZone);
  const displayValues = getDisplayValuesForZonesProductivityLegend({ zones: zonesList, hasMissingDataZone });
  const colors = hasMissingDataZone ? COLORS.productivity : COLORS.productivity.toSpliced(-1);

  return (
    <Legend
      className='productivity-legend'
      colors={colors}
      displayValues={displayValues}
      title={getMessage('table-header__review-generated-zones-yield-productivity')}
    />
  );
};

export default ProductivityLegend;
